import apiFetch from '@wordpress/api-fetch';
import { Button, PanelRow, Spinner } from '@wordpress/components';
import { dispatch, useSelect } from '@wordpress/data';
import { useEffect, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';


export default (props) => {
    const [{ imageUrl, isFetchingImage }, setState] = useState({
        imageUrl: null,
        isFetchingImage: false
    })
    const [myData, setData ] = useState(false)
    const { itineraryId } = props
    const store = useSelect(select => select('WPTravel/TripEdit'))

    const tripData = store.getAllStore()
    const itineraries = tripData.itineraries || []
    const currentItinerary = itineraries[itineraryId] || {}
    const itineraryImageId = currentItinerary.image || null
    const { updateTripData } = dispatch('WPTravel/TripEdit')

    const mediaInstance = wp.media({
        multiple: false
    })

    useEffect(() => {
        if (itineraryImageId && !imageUrl) {
            setState(state => ({
                ...state,
                isFetchingImage: true
            }))
            itineraryImageId && apiFetch({ path: `/wp/v2/media/${itineraryImageId}` })
                .then((res) => {
                    setState({
                        imageUrl: res.source_url,
                        isFetchingImage: false
                    })
                })
        }
    }, [itineraryImageId])

    mediaInstance
        .on('select', () => {
            const selectedItems = mediaInstance.state().get('selection').toJSON()
            if ( selectedItems.length > 0 ) {

                let _itineraries = itineraries
                _itineraries[itineraryId].image = selectedItems[0].id
                updateTripData({
                   ...tripData,
                   itineraries: _itineraries
               })

               setState({
                    imageUrl: null,
                    isFetchingImage: true
                })
            }
        })

    return <PanelRow>
        <label>
            {__('Image', 'wp-travel-pro')}
        </label>
        <div class="wp-travel-itinerary-image">
            {<div className="media-preview wp-travel-itinerary-image-remove">
                {isFetchingImage && <Spinner />}
                {imageUrl && <div 
                                onMouseEnter={ () => setData(true)}
                                onMouseLeave={ () => setData(false) } 
                                className='wp-travel-itinerary-image-remove-backend' > 
                    <img src={imageUrl}
                    className='wp-travel-show-image-remove' /> 
                    { myData && <Button
                        className='wp-travel-itinerary-image-remove'
                        onClick={() => { 
                            let _itinerariess = itineraries
                            _itinerariess[itineraryId].image = ''
                            updateTripData( {
                                ...tripData,
                                itineraries : _itinerariess
                            } );
                            setState({
                                imageUrl: null,
                                isFetchingImage: false
                            })
                        } }
                    >X</Button> }
                </div>}
            </div>}
            <Button variant="primary" onClick={() => mediaInstance.open()}>{ imageUrl ? __('Change image', 'wp-travel-pro' ) : __( 'Select image', 'wp-travel-pro' )}</Button>
        </div>
    </PanelRow>
}